import { mergeAll } from 'ramda';
import state from './state';
import evaluationActions from './evaluation/actions';
import evaluationMutations from './evaluation/mutations';

export default {
	state,
	actions: mergeAll([evaluationActions]),
	mutations: mergeAll([evaluationMutations]),
};



// WEBPACK FOOTER //
// ./src/modules/three-sixty-evaluation/store/index.js